import { Component } from '@angular/core';

@Component({
  selector: 'app-valid-cra',
  templateUrl: './valid-cra.component.html',
  styleUrls: ['./valid-cra.component.css']
})
export class ValidCraComponent {

}
